export default __webpack_public_path__ + "static/media/logo.3792daa8.png";